/* eslint-disable react/prop-types */

import { strCode } from "../../../consts";

import { FlexContainers, Paragraph2, Switcher, WrapperContainer } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

export const RolesFeaturesTableColumns = [
  {
    Header: strCode.FEATURE_TITLE,
    accessor: "settingName",
    Cell: ({ cell, callbackFn1: onToggleValue }) => {
      return (
        <CellWrapper width="100%">
          <WrapperContainer Container={FlexContainers.FlexRowBetween} width="100%">
            <WrapperContainer width="100%">
              <Paragraph2>{cell.value}</Paragraph2>
            </WrapperContainer>

            <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%" gap={24}>
              <Switcher
                onSwitch={() => onToggleValue(cell.row.original.settingName)}
                checked={cell.row.original.value}
                id={cell.row.original.settingName + "-switcher"}
              />
            </WrapperContainer>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
